<template>
  <div class="editor-container">
    <div v-if="selectedElement" class="card">
      <div class="card-header">
        {{ props.presetDifficulty ? 'Creation Mode' : 'Edit Mode' }}
        <span v-if="props.presetDifficulty" class="badge bg-info ms-2">
          Difficulty: {{ props.presetDifficulty }}
        </span>
      </div>
      <div class="card-body">
        <TabsComponent 
          :selectedElement="selectedElement"
          :force-open="props.autoOpen"
          :is-cat-mode="!!props.presetDifficulty"
        />
        
        <!-- Boutons pour mode création CAT -->
        <div v-if="props.presetDifficulty" class="cat-creation-actions mt-3">
          <button 
            class="btn btn-success me-2" 
            @click="confirmItemCreation"
            :disabled="!isItemValid"
          >
            <i class="fas fa-check"></i> Create Item
          </button>
          <button 
            class="btn btn-secondary" 
            @click="cancelItemCreation"
          >
            <i class="fas fa-times"></i> Cancel
          </button>
        </div>
        
        <!-- Slider de difficulté -->
        <!-- <DifficultySlider 
          v-if="selectedElement"
          v-model="selectedElement.difficulty_rating"
          @update:model-value="updateDifficulty"
        /> -->
      </div>
    </div>
    <div v-else class="alert alert-info">Select an element to edit</div>
  </div>
</template>

<script setup>
import { useTestStore } from '../../../stores/testStore';
import { computed, watch } from 'vue';
import { interactions } from '../../../config/interactions';
import { v4 as uuidv4 } from 'uuid'; // Importer UUID
import TabsComponent from "./tabCreator/TabsComponent.vue";

//import DifficultySlider from '../../common/DifficultySlider.vue';
// Props pour le mode CAT
const props = defineProps({
  element: {
    type: Object,
    default: null
  },
  presetDifficulty: {
    type: Number,
    default: null
  },
  autoOpen: {
    type: Boolean,
    default: false
  }
})

// Emits pour communiquer avec le parent CAT
const emit = defineEmits(['item-created', 'cancel-creation'])

const store = useTestStore();
const selectedElement = computed(() => props.element || store.selectedElement);

// Appliquer la difficulté prédéfinie si fournie
if (props.presetDifficulty && selectedElement.value) {
  selectedElement.value.difficulty_rating = props.presetDifficulty
}

// Validation de l'item pour la création CAT
const isItemValid = computed(() => {
  if (!selectedElement.value) return false
  
  // En mode CAT, on considère l'item valide dès qu'un type d'interaction est sélectionné
  if (props.presetDifficulty) {
    const hasType = selectedElement.value.el_Type && selectedElement.value.el_Type !== 'default'
    const hasMinimalContent = selectedElement.value.el_Text || selectedElement.value.el_RichText
    
    console.log('🔍 CAT Item validation:', {
      hasType,
      hasMinimalContent,
      el_Type: selectedElement.value.el_Type,
      el_Text: selectedElement.value.el_Text?.substring(0, 50)
    })
    
    return hasType || hasMinimalContent
  }
  
  // Validation normale pour les autres modes
  const hasContent = selectedElement.value.el_Text && selectedElement.value.el_Text.trim().length > 0
  const hasInteraction = selectedElement.value.interactions && selectedElement.value.interactions.length > 0
  
  return hasContent || hasInteraction
})

// Méthodes pour la gestion CAT
const confirmItemCreation = () => {
  console.log('🎯 Confirming item creation...', {
    hasElement: !!selectedElement.value,
    isValid: isItemValid.value,
    el_Type: selectedElement.value?.el_Type,
    presetDifficulty: props.presetDifficulty
  })
  
  if (!selectedElement.value || !isItemValid.value) {
    console.warn('❌ Cannot create item: validation failed', {
      element: selectedElement.value,
      isValid: isItemValid.value
    })
    return
  }
  
  // S'assurer que la difficulté est correctement définie
  if (props.presetDifficulty) {
    selectedElement.value.difficulty_rating = props.presetDifficulty
  }
  
  console.log('✅ Item creation confirmed - emitting event', selectedElement.value)
  emit('item-created', selectedElement.value)
}

const cancelItemCreation = () => {
  console.log('❌ Item creation cancelled')
  emit('cancel-creation')
}

// Méthode pour mettre à jour la difficulté
// const updateDifficulty = (value) => {
//   if (selectedElement.value) {
//     selectedElement.value.difficulty_rating = value;
//     store.updateElement(selectedElement.value);
//   }
// };

/* // Interaction types disponibles
const interactionTypes = interactions;

// Charger dynamiquement le modèle JSON et ajouter un el_ID
const loadInteractionModel = async (type) => {
  if (interactions[type]?.model) {
    const model = await interactions[type].model();
    // Faire une copie profonde du modèle pour éviter le partage de références
    const clonedModel = JSON.parse(JSON.stringify(model));
    store.updateElement({
      ...clonedModel,
      el_ID: uuidv4(), // Générer un identifiant unique pour le nouvel élément
    });
  }
};

// Watch pour détecter les changements de type d'interaction
watch(
  () => selectedElement.value?.el_Type,
  (newType) => {
    if (newType) {
      loadInteractionModel(newType);
    }
  }
); */
</script>

<style scoped>
/* Votre CSS reste inchangé */
.btn-sm {
  font-size: 0.875rem !important;
  padding: 0.25rem 0.5rem !important;
}

.card-header {
  background-color: #426C9C;
  color: white;
}

.inputMainPrompt {
  border: gainsboro 1px solid;
  border-radius: 5px;
  width: 100%;
  padding: 10px;
}

.mb-2 {
  margin-bottom: 10px;
}

.ia-form-container {
  border: gainsboro 1px solid;
  border-radius: 5px;
  margin-top: 20px;
  padding: 10px;

}
</style>
